export const getMaxDescription = (size: number) => `Max ${size}. characters`;
export const DomainsInputHelper =
    'To add multiple domains, seperate with a semi-colon (; )';
